var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var STEP_COUNT = 23;
var BASE_HEADERS = [
    'reference_number',
    'ts',
    'test_date',
    'birth_date',
    'language',
    'volume_level',
    'snr',
    'headphones',
    'hearing_status',
    'result_category',
];
export var RESULT_CSV_HEADERS = __spreadArray(__spreadArray([], BASE_HEADERS, true), Array.from({ length: STEP_COUNT }, function (_, index) { return [
    "".concat(index, "_snr"),
    "".concat(index, "_presented"),
    "".concat(index, "_responded"),
    "".concat(index, "_duration"),
    "".concat(index, "_pass"),
]; }).flat(), true);
export function createResultCsv(params) {
    var _a, _b, _c, _d, _e;
    var stepDurations = createStepDurations(params.steps);
    var rowValues = {
        reference_number: params.referenceNumber || '',
        ts: getUnixTimestamp(params.result.timestamp),
        test_date: toCsvTime(params.result.timestamp),
        birth_date: params.birthYear || '',
        language: params.language || 'fr',
        volume_level: (_a = params.volumeLevel) !== null && _a !== void 0 ? _a : '',
        snr: (_b = params.result.averageSnr) !== null && _b !== void 0 ? _b : '',
        headphones: typeof params.headphones === 'boolean' ? params.headphones : '',
        hearing_status: (_c = params.hearingStatus) !== null && _c !== void 0 ? _c : '',
        result_category: mapResultCategoryToInteger(params.result.category),
    };
    for (var index = 0; index < STEP_COUNT; index += 1) {
        var step = params.steps[index];
        rowValues["".concat(index, "_snr")] = (_d = step === null || step === void 0 ? void 0 : step.snr) !== null && _d !== void 0 ? _d : '';
        rowValues["".concat(index, "_presented")] = tripletToCompactString(step === null || step === void 0 ? void 0 : step.challenge);
        rowValues["".concat(index, "_responded")] = tripletToCompactString(step === null || step === void 0 ? void 0 : step.response);
        rowValues["".concat(index, "_duration")] = (_e = stepDurations[index]) !== null && _e !== void 0 ? _e : '';
        rowValues["".concat(index, "_pass")] =
            typeof (step === null || step === void 0 ? void 0 : step.passed) === 'boolean' ? step.passed : '';
    }
    var headerRow = RESULT_CSV_HEADERS.join(',');
    var valuesRow = RESULT_CSV_HEADERS.map(function (header) {
        return csvCell(rowValues[header]);
    }).join(',');
    return "".concat(headerRow, "\n").concat(valuesRow);
}
export function buildResultCsvFileName(referenceNumber, timestamp) {
    var safeReference = sanitizeReference(referenceNumber);
    var fileTimestamp = formatFileTimestamp(timestamp);
    return "".concat(safeReference, "_").concat(fileTimestamp, ".csv");
}
function sanitizeReference(referenceNumber) {
    if (!referenceNumber) {
        return 'participant';
    }
    var normalized = referenceNumber.trim().replace(/\s+/g, '-');
    var sanitized = normalized.replace(/[^a-zA-Z0-9_-]/g, '');
    return sanitized || 'participant';
}
function getUnixTimestamp(timestamp) {
    if (typeof timestamp === 'number' && Number.isFinite(timestamp)) {
        return Math.floor(timestamp);
    }
    return Math.floor(Date.now() / 1000);
}
function toCsvTime(timestamp) {
    var date = typeof timestamp === 'number' && Number.isFinite(timestamp)
        ? new Date(timestamp * 1000)
        : new Date();
    return "".concat(String(date.getHours()).padStart(2, '0'), ":").concat(String(date.getMinutes()).padStart(2, '0'), ".0");
}
function mapResultCategoryToInteger(category) {
    var _a;
    if (!category) {
        return '';
    }
    var map = {
        normal: 1,
        mild: 2,
        moderate: 3,
    };
    return (_a = map[category]) !== null && _a !== void 0 ? _a : '';
}
function formatFileTimestamp(timestamp) {
    var date = typeof timestamp === 'number' && Number.isFinite(timestamp)
        ? new Date(timestamp * 1000)
        : new Date();
    return ([
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0'),
    ].join('') +
        '.' +
        [
            String(date.getHours()).padStart(2, '0'),
            String(date.getMinutes()).padStart(2, '0'),
        ].join(''));
}
function tripletToCompactString(triplet) {
    if (!triplet || triplet.length !== 3) {
        return '';
    }
    return triplet.map(function (value) { return String(value); }).join('');
}
function csvCell(value) {
    if (value === null || typeof value === 'undefined') {
        return '';
    }
    if (typeof value === 'boolean') {
        return value ? 'TRUE' : 'FALSE';
    }
    var text = String(value);
    if (!/[",\n\r]/.test(text)) {
        return text;
    }
    return "\"".concat(text.replace(/"/g, '""'), "\"");
}
function createStepDurations(steps) {
    return Array.from({ length: STEP_COUNT }, function (_, index) {
        var _a, _b;
        var currentTimestamp = (_a = steps[index]) === null || _a === void 0 ? void 0 : _a.timestamp;
        if (!isFiniteNumber(currentTimestamp))
            return '';
        if (index === 0)
            return 0;
        var previousTimestamp = (_b = steps[index - 1]) === null || _b === void 0 ? void 0 : _b.timestamp;
        if (!isFiniteNumber(previousTimestamp))
            return '';
        var durationMs = Math.round((currentTimestamp - previousTimestamp) * 1000);
        return durationMs >= 0 ? durationMs : 0;
    });
}
function isFiniteNumber(value) {
    return typeof value === 'number' && Number.isFinite(value);
}
